import { createApi } from '@reduxjs/toolkit/query/react'
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const baseApi = createApi({
  reducerPath: 'baseApi',
  baseQuery: axiosBaseQuery({
    baseUrl: "",
  }),
  tagTypes: [],
  endpoints: () => ({
  })
});